import React, { FC, ReactNode, useEffect, ReactElement } from 'react';
import { useNavigate, Route } from 'react-router-dom';
import PrivateLayout from 'layouts/Dashboard';
import { useDispatch } from 'react-redux';
import { getAccessToken } from 'utils/storage.service';
import isAllowedTo from 'utils/isAllowedTo';

type RouterProps = {
  element: ReactElement;
  children?: ReactNode;
  path: string;
  permmissions?: string[];
};

const RouteWrapper: FC<RouterProps> = ({
  element: Component,
  children,
  ...rest
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!getAccessToken()) {
      navigate('/login', { replace: true });
    }
  }, []);

  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      element={Component}
    >
      {children}
    </Route>
  );
};

export default RouteWrapper;
